import { render, staticRenderFns } from "./AntLoading.vue?vue&type=template&id=dd2a206a&scoped=true"
import script from "./AntLoading.vue?vue&type=script&lang=js"
export * from "./AntLoading.vue?vue&type=script&lang=js"
import style0 from "./AntLoading.vue?vue&type=style&index=0&id=dd2a206a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2a206a",
  null
  
)

export default component.exports